import { MAX_CUSTOM_QUANTITY } from './page-billing-buy-bulk-constants';

/**
 * Calculate the progress bar percentage so each tier step is approximately equal width.
 * Returns a value from ~0% (at Tier 0) to ~100% (at Tier 5 / 2K+ units).
 */
export function calculateProgressBarPercentage(queryAmount: number): number {
  const minTier = 0;
  const maxTier = MAX_CUSTOM_QUANTITY;

  if (queryAmount <= minTier) return 0;

  // Iterate through each tier step, adding ~20% per step
  let currentAmount = minTier;
  let currentPercent = 0;
  const segments = 100 / (4 - 1);
  for (let i = 1; i <= 6; i++) {
    const nextAmount = TIER_MARKS[i + 1]?.amount ?? maxTier;
    if (queryAmount <= nextAmount) {
      // Linear interpolation within this tier step
      const ratio =
        (queryAmount - currentAmount) / (nextAmount - currentAmount);
      return Math.min(Math.round(currentPercent + ratio * segments), 100);
    } else {
      currentAmount = nextAmount;
      currentPercent += segments;
    }
  }

  // At or past the max tier (2K) - calculate percentage for custom/above-tier amounts
  return Math.min(Math.round((queryAmount / maxTier) * 100), 100);
}
/**
 * Tier options displayed on the progress bar. Each entry maps a label to its actual numeric value.
 */

export const TIER_MARKS: Record<number, { label: string; amount: number }> = {
  1: { label: '1', amount: 1 },
  2: { label: '10', amount: 50 },
  3: { label: '150', amount: 150 },
  4: { label: '300', amount: MAX_CUSTOM_QUANTITY }
};
/**
 * Calculate the savings percentage based on tier-based pricing.
 */
export function calculateSavingsPercentage(queryAmount: number): number {
  const t1 = TIER_MARKS[1].amount ?? 1;
  if (queryAmount <= t1) return 0;

  // Simplified: as quantity increases, savings grows proportionally up to a cap
  const maxQuantity = Math.max(TIER_MARKS[5].amount, MAX_CUSTOM_QUANTITY);
  const ratio = queryAmount / maxQuantity;
  return Math.min(ratio * 100, 95);
}
